/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import PalletsApi from '../../../../services/api/PalletsApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from '../validationSchema';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';
import styled from 'styled-components';

export default function PalletEdit(): React.ReactElement {
  const { id } = useParams();
  const [itemData, setItemData] = useState({
    name: '',
    width: '',
    length: '',
    height: '',
    weight: '',
    dataArrived: false,
  });
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let res = null;
    if (id) {
      res = await PalletsApi.update(id, values);
    } else {
      res = await PalletsApi.create(values);
    }
    if (res.status === StatusCodes.OK) {
      history.push('/pallets');
    } else {
      setSubmitting(false);
    }
  };

  const getItem = async () => {
    const res = await PalletsApi.get(id);
    const newItemData = { ...res.data, dataArrived: true };
    setItemData(newItemData);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <>
      <WhitePad>
        <TitleComponent
          title={`${id ? 'Edit ' : 'Create '}Pallet`}
          onLeftHandler={() => {
            history.goBack();
          }}
        />
        <FormWrapper>
          {id && itemData.dataArrived === false ? null : (
            <Formik
              initialValues={{
                name: itemData.name,
                width: itemData.width,
                length: itemData.length,
                height: itemData.height,
                weight: itemData.weight,
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                return saveItem(values, setSubmitting);
              }}
            >
              {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                  <FormRow>
                    <TextInputComponent
                      name="name"
                      label="Name"
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={12}
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="width"
                      label="Width (cm)"
                      value={values.width}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={6}
                      type="number"
                    />
                    <TextInputComponent
                      name="length"
                      label="Length (cm)"
                      value={values.length}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={6}
                      type="number"
                    />
                  </FormRow>
                  <FormRow>
                    <TextInputComponent
                      name="height"
                      label="Height (cm)"
                      value={values.height}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={6}
                      type="number"
                    />
                    <TextInputComponent
                      name="weight"
                      label="Weight (kg)"
                      value={values.weight}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      cols={6}
                      type="number"
                    />
                  </FormRow>
                  <ActionWrapper>
                    <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
                    {/* <BorderlessButton
                      marginLeft="30px"
                      size="sm"
                      type="submit"
                      onClick={onDelete}
                      title="Delete"
                    /> */}
                  </ActionWrapper>
                </form>
              )}
            </Formik>
          )}
        </FormWrapper>
      </WhitePad>
    </>
  );
}

const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
`;
